import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  ViewChild,Inject, PLATFORM_ID
} from '@angular/core';
import { Subject, Subscription, async } from 'rxjs';
import { ApiService } from '../../shared/services/apiService.service';
import { CommonService } from '../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { RootService } from '../../shared/services/root.service';
import { environment } from '../../../environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { WishlistService } from 'src/app/shared/services/wishlist.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OtpComponent implements OnInit {
  environment1 = environment.s3bucket.url;
  sub: Subscription = new Subscription();
  @ViewChild('OtpInput') OtpInputRef: any;
  @ViewChild('ngOtpInput') ngOtpInput: any;
  @Output() checkOTP = new EventEmitter<any>();
  @Output() enteredOtp = new EventEmitter<any>();
  @Output() loadSignup: EventEmitter<void> = new EventEmitter<void>();
  otpValue: any;
  isVliadOtp: boolean = false;
  loginId: any;
  centerBanners: any;
  m: any;
  s: any;
  timeLeft: any;
  destroy = new Subject();
  @Input() isTimer: boolean = false;
  isKeyAccountAvl: boolean = false;
  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    autoplay: true,
    // nav: true,
    responsiveRefreshRate: 1000000,
    // navText: [
    // "<img class='nav' src='https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/crasual-left.svg' alt='crasual-left' />",
    // "<img class='nav' src='https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/crasual-right.svg' alt='crasual-left' />"
    // ],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
  };
  isLoading: any = false;
  banners: any = [];
  popularVehicleList: any;
  isVerify: boolean = false;
 
  isTataOk: boolean = false;
  isUserLoggedIn: boolean = false;

  constructor(
    private apiService: ApiService,
    private storageService: RootService,
    private localStorage: secureStorage,
    private behaviourSubject: BehaviourSubjectService,
    private wishlistService: WishlistService,
    private loginService: CommonService,
    private toastrService: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private cleverService: ClevertapService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Otp Page");
      } catch { }
    }
    this.startTimer(120);
    this.isTataOk = window.location.href.includes('buy-used-vehicles');
    this.behaviourSubject.loginNumber.subscribe((value) => {
      this.loginId = JSON.parse(this.localStorage.getItem('loginNumber'));
    });
    this.getBanners();
    setTimeout(() => {
      this.setBannerList();
    }, 2000);
  }

  OTPChecker(event: any) {
    if (event?.length === 6) {
      this.otpValue = event;
      this.isVliadOtp = true;
    } else this.isVliadOtp = false;
    this.enteredOtp.emit(event);
  }
  onClickVerify() {

    if (this.isVerify) {
      return;
    }
    this.isVerify = true;

    if (this.otpValue?.length == 0 || this.otpValue?.length < 6) {
      this.spinner.hide();

      this.toastrService.warning('Please enter OTP');
      return;
    }
    let data = { mobile_number: this.loginId, otp_number: this.otpValue };
    this.spinner.show();
    this.sub.add(
      this.apiService.verifyOtp(data).subscribe({
        next: (response: any) => {

          if(response){
            this.isVerify = false;
            this.spinner.hide();
          }
          if (response.success) {
            setTimeout(() => {
              this.isUserLoggedIn = this.storageService.isLoggedIn() ? true : false;
              if(this.isUserLoggedIn)
              this.behaviourSubject.isTataOkLogin.next(true);
            }, 2000);
            if (response.success && response?.data?.msg == 'User is not Registered!') {

              this.isVerify = false;

              // this.ngOtpInput.setValue('');
                this.toastrService.warning(response.data.msg);
              this.loadSignup.emit();
            }
            else {

              if (isPlatformBrowser(this.platformId)) {
                this.vasCount(this.loginId);
                localStorage.setItem('isKeyAccountAvl', 'true');
                localStorage.setItem('isKeymobile', this.loginId);

                this.isVerify = false;

                let data = localStorage.getItem('signup');
                if (data) {
                  try {
                    this.cleverService.onTransactionFlowSignUpSuccess();
                  } catch { }
                }
              }
              if(!window.location.href.includes('buy-used-vehicles') && !window.location.href.includes('buy-used-vehicles-productdetail') && !window.location.href.includes('buy-used-vehicles-productdetail')){
                this.toastrService.success('Login Successfully');
              }
              this.storageService.loginUser(response.data);
              if (isPlatformBrowser(this.platformId)) {
                try {
                  this.cleverService.onUserLogFunc(response.data.first_name, response.data.last_name, response.data.email_id, response.data.mobile_number);

                  this.cleverService.onUserLogin(response.data.first_name + ' ' + response.data.last_name, response.data.email_id, response.data.mobile_number);
                } catch { }
              }
              let wishList: any = [];
              wishList = this.wishlistService.getWishlist();
              if (wishList?.length > 0) {
                let data = JSON.parse(localStorage.getItem('wishlist'));
                this.addToWishlist(data);
              }
              // this.router.navigate(['home'])

                if (localStorage.getItem('catIdid') == 'true'){
                  let path = JSON.parse(localStorage.getItem('previousUrl'))
                ? JSON.parse(localStorage.getItem('previousUrl'))
                : 'home';

                this.router.navigate([path.url], { queryParams: { catId: path.query } });
                }else{
                  let path = localStorage.getItem('previousUrl')
                  ? localStorage.getItem('previousUrl')
                  : 'home';
                if (path.includes('lead-booking?vc') || path.includes('lead-booking?dealer')) {
                  if (
                    localStorage.getItem('dealercd') ||
                    localStorage.getItem('vc')
                  ) {
                    if (
                      localStorage.getItem('dealercd') &&
                      localStorage.getItem('vc')
                    ) {
                      this.router.navigate(['/lead-booking'], {
                        queryParams: {
                          dealer: localStorage.getItem('dealercd'),
                          vc: localStorage.getItem('vc'),
                        },
                      });
                    } else if (localStorage.getItem('dealercd')) {
                      this.router.navigate(['/lead-booking'], {
                        queryParams: {
                          dealer: localStorage.getItem('dealercd'),
                        },
                      });
                    } else {
                      this.router.navigate(['/lead-booking'], {
                        queryParams: { vc: localStorage.getItem('vc') },
                      });
                    }
                  }
                } else {
                        this.router.navigate([path]);
                }
                }
              // localStorage.removeItem("previousUrl");
            }
          }
          else {
            this.isVerify = false;

            // this.ngOtpInput.setValue('');
            this.toastrService.warning(response.data.msg);
          }
        },
        error: () => {
          this.isVerify = false;

          // this.toastrService.warning("Something went wrong!")
          this.spinner.hide();
          this.toastrService.warning(
            'Your account is locked due to multiple incorrect OTP. Please try after sometime'
          );
        },
        complete: () => {
          this.spinner.hide();
        },
      })
    );
  }

  addToWishlist(event: any) {
    let data = {
      product: event,
      action_type: 'add',
    };
    this.sub.add(
      this.apiService.addToWishlist(data).subscribe({
        next: (res: any) => {
          localStorage.removeItem('wishlist');
        },
        error: () => {},
        complete: () => {},
      })
    );
  }

  getBanners() {
    this.loginService.getBannerList();
  }

  setBannerList() {
    this.banners = this.loginService.bannerList;
    if (this.banners?.length > 0) {
      this.isLoading = true;
      this.centerBanners = this.banners;
    }
  }

  GetTest(data: any) {
    let url;
    var dataUrl = data.banner_link;
    if (dataUrl) {
      url =
        dataUrl?.replace('https://', '') &&
        dataUrl?.replace(environment.baseUrl, '');
      this.router.navigateByUrl(url);
    }
  }
  resendOTP() {
    if (!this.isTimer && this.timeLeft <= 0) {
      this.ngOtpInput.setValue('');
      this.otpValue = '';
      if (this.OtpInputRef) {
        this.OtpInputRef.setValue('');
      }
      this.sentOtp();
      this.startTimer(120);
    }
  }
  sentOtp() {
    this.spinner.show();
    let data = {
      mobile_number: this.loginId,
      action_type: 'login',
    };
    this.sub.add(
      this.apiService.sentOtp1(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.toastrService.success(response.data.msg);
            this.spinner.hide();
            // this.mobile_no.emit(this.mobileNo);
            // this.commonService.mobileNo = this.mobileNo;
            // this.behaviorService.loginNumber.next(true)
            // this.localStorage.setItem("loginNumber", JSON.stringify(this.mobileNo))

            // this.router.navigate(['/otp/']);
              window.scroll(0, 0);
          } else {
            this.spinner.hide();
            if (response?.data?.msg == 'User is not registered.') {
              // this.behaviorService.loginNumber.next(true)
              // this.localStorage.setItem("loginNumber", JSON.stringify(this.mobileNo))
              this.router.navigate(['/signup']);
              // this.toastrService.warning(response.data.msg || response.msg);
            } else {
              this.toastrService.warning('Something went wrong!');
              this.spinner.hide();
            }
          }
        },
        error: () => {
          this.toastrService.warning('Something went wrong!');
          this.spinner.hide();
        },
        complete: () => {},
      })
    );
  }
  startTimer(timeLeft: any) {
    this.timeLeft = timeLeft;
    const interval = setInterval(() => {
      this.isTimer = true;
      this.m = Math.floor(this.timeLeft / 60);
      this.s = this.timeLeft % 60;
      this.m = this.m < 10 ? '0' + this.m : this.m;
      this.s = this.s < 10 ? '0' + this.s : this.s;
      this.timeLeft--;
      if (this.timeLeft < 0) {
        this.isTimer = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  vasCount(value){
    const signup=JSON.parse(this.localStorage.getItem("signup")) ? true : false;
     let data ={
         "mobile_number": value,
         'source':signup? 'Web Registration' :'Web Login'
     }
         this.apiService.get_amc_consent_view(data).subscribe((res)=>{
         })
  }

  @Output() loadParent: EventEmitter<void> = new EventEmitter<void>();
  backToLogin() {
    this.loadParent.emit();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
